// extracted by mini-css-extract-plugin
var _1 = "FundingStyle-module__break-words___GgHKF";
var _2 = "FundingStyle-module__break-words___GgHKF";
var _3 = "FundingStyle-module__disclosed-funding___LKe5y";
var _4 = "FundingStyle-module__disclosed-funding___LKe5y";
var _5 = "FundingStyle-module__edit-button___fmPu7";
var _6 = "FundingStyle-module__edit-button___fmPu7";
var _7 = "FundingStyle-module__empty___D2e4n";
var _8 = "FundingStyle-module__external-link___ZzqSf";
var _9 = "FundingStyle-module__external-link___ZzqSf";
var _a = "FundingStyle-module__flag___CxNGM";
var _b = "FundingStyle-module__funding___cOyfu";
var _c = "FundingStyle-module__mobile-hide___N5_F_";
var _d = "FundingStyle-module__mobile-hide___N5_F_";
var _e = "FundingStyle-module__not-known___yyEg7";
var _f = "FundingStyle-module__not-known___yyEg7";
var _10 = "FundingStyle-module__row___ZAQnG";
var _11 = "FundingStyle-module__row-editing___USzD5";
var _12 = "FundingStyle-module__row-editmode___rt5eG";
var _13 = "FundingStyle-module__row-editing___USzD5";
var _14 = "FundingStyle-module__row-editmode___rt5eG";
var _15 = "FundingStyle-module__uppercase___Bq6nD";
export { _1 as "break-words", _2 as "breakWords", _3 as "disclosed-funding", _4 as "disclosedFunding", _5 as "edit-button", _6 as "editButton", _7 as "empty", _8 as "external-link", _9 as "externalLink", _a as "flag", _b as "funding", _c as "mobile-hide", _d as "mobileHide", _e as "not-known", _f as "notKnown", _10 as "row", _11 as "row-editing", _12 as "row-editmode", _13 as "rowEditing", _14 as "rowEditmode", _15 as "uppercase" }
